import { cva, type VariantProps } from 'class-variance-authority';
import type { LucideIcon } from 'lucide-react';
import type { FC } from 'react';
import { cn } from '../lib/utils';

export const iconTileVariants = cva(
  'inline-flex shrink-0 items-center justify-center rounded-lg border',
  {
    variants: {
      tone: {
        neutral: 'border-border bg-surface-hover text-[color:var(--z-text-secondary)]',
        brand: 'border-brand-border bg-brand-subtle text-brand'
      },
      size: {
        sm: 'size-7 [&_svg]:size-3.5',
        md: 'size-9 [&_svg]:size-4'
      }
    },
    defaultVariants: { tone: 'neutral', size: 'sm' }
  }
);

interface IconTileProps extends VariantProps<typeof iconTileVariants> {
  icon: LucideIcon;
  className?: string;
}

/** The rounded square an icon sits in at the start of a card, menu row or panel header. */
export const IconTile: FC<IconTileProps> = ({ icon: Icon, tone, size, className }) => (
  <span aria-hidden="true" className={cn(iconTileVariants({ tone, size }), className)}>
    <Icon />
  </span>
);
